import React from "react";
import Navigation from "./navigation.js";
import Contactussection from "./contactussection.js"; // Adjust the path as necessary
import aboutframe from '../assets/aboutframe.png'; // Adjust the path as necessary
import target1 from '../assets/target1.png'; // Adjust the path as necessary
import aboutimg from '../assets/aboutimg.png'; // Adjust the path as necessary      
const Aboutuspage = () => {
    return (

        <div className="apple">
            <Navigation />

            <div className="max-width" >

                <div className="page-main-heading">About Ren</div>

                <div className="page-sub-heading">Providing Best Business Security & Automation <br /> Solutions For Your Premises</div>

                <img src={aboutframe} className="about-frame" alt=" writtedn" />

                <div className="horizontal gap-20 align-center">

                    <div className="full-width who-we-are-container">
                        <h2 className="who-we-are">Who We Are</h2>
                        <p>ASG Systems is a leading provider of comprehensive security and automation solutions. With over two decades of experience, we have established ourselves as a trusted name in the industry. Our commitment to excellence and innovation has enabled us to deliver cutting-edge solutions that meet the diverse needs of our clients.</p>
                    </div>

                    <div className="full-width">
                        <img src={aboutimg} className="about-img" alt="" />
                    </div>


                </div>


                
                <div className="page-main-heading">Our Mission </div>

                <div className="page-sub-heading">
                To create safer, smarter, and more efficient environments by providing reliable and innovative security and automation solutions.
                    </div>

                <img src={aboutframe} className="about-frame" alt=" writtedn" />


                <div className="contact-img-containera">


                    <img src={target1} className="full-width " alt="asg contact" />


                </div>


                <div className="bussiness-partner-text">Business Partners</div>
                <div className="bussiness-partner-text2">Automation Solutions</div>
                <div className="clients-images-container">

                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                </div>


                <div className="bussiness-partner-text2">Security Solutions</div>
                <div className="clients-images-container">

                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                </div>



                <div className="bussiness-partner-text2">Tensile Structure / Skylight Structures</div>
                <div className="clients-images-container">

                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                    <img src={target1} className="full-width clients-images" alt="asg contact" />
                </div>

                <div className="margin-section"></div>


            </div >


            <Contactussection />

        </div >


    );
}

export default Aboutuspage;